import { SourceDataVerificationPermission, PostHasPermissions, PostHasPermissionsResponse, SourceDataVerificationRequestContext  } from '@/api/dtos';
import { useGet, usePost } from '@ngt/forms';
import { useCallback, useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getError = (response?: SWRResponse<PostHasPermissionsResponse, PostHasPermissionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const usePermissions = (
    permissions?: SourceDataVerificationPermission[],
    loadingContext?: boolean,
    trialId?: number,
    masterGroupId?: number,
    coordinatingGroupId?: number,
    countryId?: number,
    institutionId?: number,
    patientId?: number,
    formDefinitionId?: number,
    formId?: number,
    fileId?: number,
    configuration?: SWRConfiguration
) => {

    const getData = useCallback((response?: SWRResponse<PostHasPermissionsResponse, PostHasPermissionsResponse>) => {
        return permissions?.map(p => !!response?.data?.permissions?.[p]) ?? [];
    }, [...(permissions ?? [])]);

    const request = useMemo(() => {
        return !loadingContext && permissions ? 
            () => new PostHasPermissions({
                context: new SourceDataVerificationRequestContext({
                    trialId, masterGroupId, coordinatingGroupId, countryId, institutionId, patientId, formDefinitionId, formId, fileId
                }),
                permissions 
            }) : 
            undefined;
    }, [loadingContext, trialId, masterGroupId, coordinatingGroupId, countryId, institutionId, patientId, formDefinitionId, formId, fileId, ...(permissions ?? [])]);

    const result = usePost(request, { getData, getError}, configuration);

    return request ?
        result :
        {
            ...result,
            loading: true
        }
};

export default usePermissions;